import { render, staticRenderFns } from "./loader.vue?vue&type=template&id=89abcd92&scoped=true&"
import script from "./loader.vue?vue&type=script&lang=js&"
export * from "./loader.vue?vue&type=script&lang=js&"
function injectStyles (context) {
  
  var style0 = require("./loader.vue?vue&type=style&index=0&id=89abcd92&scoped=true&lang=scss&")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "89abcd92",
  null
  ,true
)

export default component.exports